import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../shared/common.service';
import { TranslationService } from '../shared/translation.service';
import { BoardService } from '../board/board.service';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.css']
})
export class RootComponent implements OnInit {
  token="";
  boardId;
  authError="";
  constructor(public translate:TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    public translationService:TranslationService,
    public commonService:CommonService,
    private boardService: BoardService){

  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
        this.token = params['token'];
       this.commonService.boardIdFromGame= parseInt(params['boardId']);
       this.commonService.selectedlang= params['lang'];
       const parsedBoardId = parseInt(params['boardId']);
      const parseCardId=parseInt(params['cardId'])
      const parseSectionId=parseInt(params['sectionId'])
       if (isNaN(parsedBoardId)) {
        this.commonService.boardIdFromGame = 0;
         }
         else{
        this.commonService.boardIdFromGame = parsedBoardId;
        }  
      if (isNaN(parseCardId)) {
          this.commonService.cardId = 0;
           }
           else{
          this.commonService.cardId = parseCardId;
          }   
          if (isNaN(parseSectionId)) {
            this.commonService.sectionId = 0;
             }
             else{
            this.commonService.sectionId = parseSectionId;
            }     
        // dev code end

        // local server
      // this.token='684137c38397bd79874b4fef'
      // this.commonService.selectedlang='de'


      this.translationService.setSelectedlanguage( this.commonService.selectedlang)
      if (!this.token) {
        this.authError = 'Open the app with /?token=... (and optional &lang=en).';
        this.commonService.loaderFlag = false;
        console.error('Missing auth token. Open the app with ?token=... (and optional &lang=en).');
        return;
      }
      if (this.isJwt(this.token)) {
        localStorage.setItem('token', this.token);
        this.boardService.onReloadGetInfo().subscribe(
          res => this.enterSession(res),
          err => this.failAuth('Token validation failed. Check the session token and try again.', err)
        );
        return;
      }
      this.commonService.getBordValidToken(this.token).subscribe(
        res => this.enterSession(res),
        err => this.failAuth('Token validation failed. Check the session token and try again.', err)
      )
    })
    }

  private isJwt(token: string): boolean {
    return !!token && token.split('.').length === 3 && token.startsWith('eyJ');
  }

  private enterSession(res: any) {
    if (!res || !res.user) {
      this.failAuth('Token validation failed. Check the session token and try again.', res);
      return;
    }
    this.commonService.applySessionUser(res.user);
    if (res.token) {
      this.token = res.token;
      localStorage.setItem('token', this.token);
    }
    this.translate.setDefaultLang(this.commonService.selectedlang);
    this.translate.use(this.commonService.selectedlang);
    this.router.navigate(['/board']);
  }

  private failAuth(message: string, err: any) {
    this.authError = message;
    this.commonService.loaderFlag = false;
    console.error('Token validation failed', err);
  }
}
